
import { enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';
import { GlobalErrorHandlerService } from './app/shared/service/global-error-handler.service';
import { EnvServiceProvider } from './app/env-service/env.service.provider';
import { ManagedContentService } from './app/shared/service/managed-content.service';
import { UserSessionService } from './app/shared/service/user-session.service';
import { DeactivateGuard } from './app/deactivate.guard';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { GlobalHttpLoggingInterceptorService } from './app/shared/service/global-http-logging-interceptor.service';
import { WindowRef } from './app/shared/service/window.service';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from './app/app-routing.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, AppRoutingModule, CommonModule, FormsModule, ReactiveFormsModule, HttpClientModule, 
        // SFG lib
        BackButtonDisableModule.forRoot({
            preserveScroll: true,
        })),
        { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
        EnvServiceProvider,
        ManagedContentService,
        UserSessionService,
        DeactivateGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: GlobalHttpLoggingInterceptorService,
            multi: true,
        },
        WindowRef,
        provideAnimations(),
    ]
})
  .catch(err => console.error(err));
